import axios, { InternalAxiosRequestConfig, AxiosError, AxiosResponse } from 'axios';
import config from './config';
import { TResponse } from '../types/common';
import { getToken } from './utils';

const axiosInstance = axios.create({
    baseURL: config.apiUrl
});

axiosInstance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
        config.headers.authorization = "Bearer " + getToken();
            // to bypass ngrok warning
            // config.headers["ngrok-skip-browser-warning"] = "2525"
            return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => {
      
        return response;
    },
    (error: AxiosError) => {
        let response: TResponse<any> = {
            success: false,
            message: "Something went wrong",
            code: 500,
            data: null
        };
        if (error.response?.data) {
            const data = error.response.data as Partial<TResponse>;
            response.message = data.message ?? error.message;
            if (Array.isArray(data.errors) && data.errors.length > 0) {
                response.message = data.errors[0].msg;
                response.errors = data.errors;
            }
        } else {
            response.message = error.message;
        }

        return Promise.reject(response);
    },
);

export default axiosInstance;